import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'

const InvoiceScreen = props => {
  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Factura {props.selectedInvoiceCode}</Typography>
          </div>
          <div className="right" />
        </Toolbar>
      )}>
      <iframe
        title="invoice"
        className={props.classes.iframe}
        src={props.selectedInvoiceUrl + '&rand=' + Date.now()}
        id="theframe"
        name={'' + Date.now() + ''}>
        {/* <script>
          let _theframe = document.getElementById("theframe") _theframe.contentWindow.location.href = _theframe.src
        </script> */}
      </iframe>
    </Page>
  )
}

const styles = {
  appBar: {
    background: '#1B458E',
  },
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
}

export default withStyles(styles)(InvoiceScreen)



// WEBPACK FOOTER //
// ./src/screens/InvoiceScreen.js